<template>
  <mds-modal
    action-required
    class="frequency-modal"
    :class="{ 'frequency-modal--holiday-recurrence': holidayRecurrence }"
    :fullscreen="false"
    :visible="showFrequencyModal"
    width="600px"
  >
    <frequency-modal-wrapper
      v-bind="$props"
      v-on="$listeners"
      @close="close"
      @holidayRecurrence="holidayRecurrence = $event"
    />
  </mds-modal>
</template>
<script>
import MdsModal from '@mds/modal'
import FrequencyModalWrapper from '@/components/frequencyModal/FrequencyModalWrapper.vue'
import { CLOSE_MESSAGE } from '@/components/schedulerModal/config/constants'

export default {
  name: 'FrequencyModal',
  components: {
    MdsModal,
    FrequencyModalWrapper,
  },
  props: {
    showFrequencyModal: Boolean,
    modalLoading: Boolean,
    saveScheduleResponse: Boolean,
    saveScheduleStatus: Boolean,
    hasDuplicateName: Boolean,
    feedId: undefined,
  },
  data() {
    return {
      holidayRecurrence: false,
    }
  },
  methods: {
    close() {
      window.chrome?.webview?.postMessage(CLOSE_MESSAGE)
    },
  },
}
</script>
<style lang="scss" scoped>
.frequency-modal {
  &::v-deep > [class^='mds-modal__wrapper'] {
    height: 670px;
    [class^='mds-modal__content'] {
      flex-direction: column;
    }
  }
  &--holiday-recurrence {
    &::v-deep > [class^='mds-modal__wrapper'] {
      height: 800px;
    }
  }
}
</style>
